// Fallback constants for MSP — used when the msp remote is unavailable.
// Must stay in sync with exports from app_msp.
// Maybe move this to common

export enum MSPServiceCode {
  SOCIAL_PROTECT = 'social_protect',
}

export const MSP_ROUTES_FALLBACK = {
  SOCIAL_PROTECT: '/msp/services/social-protect',
  FACILITY: '/msp/services/facility',
  PERSONAL_RECORD_DATA: '/msp/personal-record/data',
  NEEDS: '/msp/personal-record/needs',
  MENTOR: '/msp/personal-record/mentor',
  SERVICE: '/msp/personal-record/service',
  TREATMENT: '/msp/personal-record/treatment',
  SUPPORT: '/msp/personal-record/support',
  INVALIDITIES: '/msp/personal-record/invalidities',
  INCIDENTS: '/msp/personal-record/incidents',
  NEWS: '/msp/news',
  NEWS_DETAILED: '/msp/news/:id',
} as const;
